import React from 'react';
import { Cell, Grid } from 'styled-css-grid';

import { Skeleton } from '@crm-framework/skeleton';
import { Spacing } from '@crm-framework/spacing';
import { ActionsButtonsSkeleton } from '@crm-framework/actions-buttons';

const TEXT_HEIGHT = 16;
const INPUT_HEIGHT = 34;
const TEXTAREA_HEIGHT = 106;
const MARGIN_BOTTOM = 8;

const InputSkeleton = ({ labelWidth = 60 }) => (
  <>
    <Spacing mb={MARGIN_BOTTOM}>
      <Cell>
        <Skeleton width={labelWidth} height={TEXT_HEIGHT} />
      </Cell>
    </Spacing>
    <Spacing mb={MARGIN_BOTTOM}>
      <Cell>
        <Skeleton height={INPUT_HEIGHT} />
      </Cell>
    </Spacing>
  </>
);
const TextareaSkeleton = ({ labelWidth = 60 }) => (
  <>
    <Spacing mb={MARGIN_BOTTOM}>
      <Skeleton
        width={labelWidth}
        height={TEXT_HEIGHT}
        wrapperComponent={Cell}
      />
    </Spacing>
    <Spacing mb={MARGIN_BOTTOM}>
      <Skeleton height={TEXTAREA_HEIGHT} wrapperComponent={Cell} />
    </Spacing>
  </>
);

interface IPlaceholder {
  label: string;
  component: React.FC<{ labelWidth?: number }>;
}
const placeholders: IPlaceholder[] = [
  {
    label: 'Name',
    component: InputSkeleton,
  },
  {
    label: 'Internal Description',
    component: TextareaSkeleton,
  },
  {
    label: 'Minimum Deposit Amount',
    component: InputSkeleton,
  },
  {
    label: 'Max Usage',
    component: InputSkeleton,
  },
  {
    label: 'Type',
    component: InputSkeleton,
  },
  {
    label: 'Visible',
    component: InputSkeleton,
  },
  {
    label: 'Is Fully Activated',
    component: InputSkeleton,
  },
  {
    label: 'Valid From',
    component: InputSkeleton,
  },
  {
    label: 'Valid To',
    component: InputSkeleton,
  },
  {
    label: 'Business Units',
    component: InputSkeleton,
  },
  {
    label: 'Unnamed placeholder',
    component: InputSkeleton,
  },
  {
    label: 'I like sushi',
    component: InputSkeleton,
  },
  {
    label: 'Need link, but we havent it',
    component: InputSkeleton,
  },
  {
    label: 'Some label',
    component: InputSkeleton,
  },
  {
    label: 'Big text',
    component: TextareaSkeleton,
  },
  {
    label: 'Very big text',
    component: TextareaSkeleton,
  },
];

const letterWidth = 8;

export const PromoSkeleton = () => (
  <Grid flow="row" columns={1} gap="0">
    <Grid columns="50% 50%">
      {placeholders.map(({ label, component }: IPlaceholder) => {
        const Component = component;
        const labelWidth = label.length * letterWidth;

        return <Component key={label} labelWidth={labelWidth} />;
      })}
    </Grid>
    <ActionsButtonsSkeleton buttons={2} />
  </Grid>
);
